// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --bg-primary: #1a1a2e;
  --bg-secondary: #16213e;
  --bg-card: #1e2a47;
  --bg-card-hover: #243352;
  --bg-input: #0f1729;
  --text-primary: #e8e8f0;
  --text-secondary: #a8a8c0;
  --text-muted: #6a6a88;
  --accent-gold: #d4a03c;
  --accent-gold-dim: #b8882e;
  --accent-teal: #4a90a4;
  --accent-green: #5ba08f;
  --accent-warm: #d99a3e;
  --accent-rose: #c95e5e;
  --border-color: #2a3556;
  --border-light: #354170;
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
  --transition: 0.2s ease;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  min-height: 100vh;
  transition: background-color 0.5s ease;
}

#root {
  min-height: 100vh;
}

a {
  color: var(--accent-teal);
  text-decoration: none;
}

a:hover {
  color: var(--accent-gold);
}

ul, ol {
  padding-left: 1.5em;
}

li {
  margin-bottom: 0.3em;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --bg-primary: #1a1a2e;\n  --bg-secondary: #16213e;\n  --bg-card: #1e2a47;\n  --bg-card-hover: #243352;\n  --bg-input: #0f1729;\n  --text-primary: #e8e8f0;\n  --text-secondary: #a8a8c0;\n  --text-muted: #6a6a88;\n  --accent-gold: #d4a03c;\n  --accent-gold-dim: #b8882e;\n  --accent-teal: #4a90a4;\n  --accent-green: #5ba08f;\n  --accent-warm: #d99a3e;\n  --accent-rose: #c95e5e;\n  --border-color: #2a3556;\n  --border-light: #354170;\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 16px;\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);\n  --transition: 0.2s ease;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: \"Segoe UI\", system-ui, -apple-system, sans-serif;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  min-height: 100vh;\n  transition: background-color 0.5s ease;\n}\n\n#root {\n  min-height: 100vh;\n}\n\na {\n  color: var(--accent-teal);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--accent-gold);\n}\n\nul, ol {\n  padding-left: 1.5em;\n}\n\nli {\n  margin-bottom: 0.3em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
